
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("Vjn6T", function(module, exports) {

$parcel$export(module.exports, "EditorAppearanceButtonNext", () => $b6a305a656accd1c$export$b00e22884b6dd9a);

var $gwFzn = parcelRequire("gwFzn");

var $hp2SH = parcelRequire("hp2SH");

var $jXpbL = parcelRequire("jXpbL");

var $2HGN8 = parcelRequire("2HGN8");

var $8u6tU = parcelRequire("8u6tU");

var $eqLeF = parcelRequire("eqLeF");
const $b6a305a656accd1c$export$b00e22884b6dd9a = ({ contentId: contentId, isStatusDisconnected: isStatusDisconnected, disabled: disabled = false })=>{
    const { contentAppearance: contentAppearance, setContentAppearance: setContentAppearance, contentAppearanceLoading: contentAppearanceLoading } = (0, $2HGN8.useContentAppearance)();
    const [{ collabEditProvider: collabEditProvider, collabEditInitialized: collabEditInitialized }] = (0, $jXpbL.useNativeCollabState)();
    const updateContentAppearanceProperty = async (params)=>{
        const client = (0, $hp2SH.getApolloClient)();
        const payload = {
            contentId: params.contentId,
            propertyKey: params.propertyKey,
            propertyValue: params.propertyValue,
            versionNumber: params.versionNumber.toString(),
            isDelete: false
        };
        const result = await client.mutate({
            mutation: (0, $eqLeF.UpdateContentAppearancePropertyMutation),
            variables: payload
        });
        if (result?.data?.experimentalUpdateContentProperty?.success) setContentAppearance({
            appearance: params.propertyValue,
            version: params.versionNumber
        });
    };
    const isDisabled = contentAppearanceLoading || !collabEditInitialized || disabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8u6tU.EditorAppearanceButtonComponent), {
        contentId: contentId,
        collabEditProvider: collabEditProvider,
        isDisabled: isDisabled,
        isStatusDisconnected: isStatusDisconnected,
        updateContentAppearanceProperty: updateContentAppearanceProperty,
        contentAppearanceDraft: contentAppearance
    });
};

});
parcelRegister("eqLeF", function(module, exports) {

$parcel$export(module.exports, "UpdateContentAppearancePropertyMutation", () => $22f1257be4b783e7$export$35397ce5f8c2270c);

var $d2LG0 = parcelRequire("d2LG0");
const $22f1257be4b783e7$export$35397ce5f8c2270c = (0, $d2LG0.default)`mutation UpdateContentAppearancePropertyMutation($contentId:String!$propertyKey:String!$propertyValue:String!$versionNumber:String!$isDelete:Boolean)@experimental{experimentalUpdateContentProperty(contentId:$contentId propertyKey:$propertyKey propertyValue:$propertyValue versionNumber:$versionNumber isDelete:$isDelete){success id key value}}`;

});



//# sourceMappingURL=EditorAppearanceButtonNext.4dc7a045.js.map
